module.exports = __webpack_public_path__ + "img/hr-green-small-grass-05.375427af.png";